import { render, staticRenderFns } from "./resumen_pendientes.vue?vue&type=template&id=64a76b55&scoped=true"
import script from "./resumen_pendientes.vue?vue&type=script&lang=js"
export * from "./resumen_pendientes.vue?vue&type=script&lang=js"
import style0 from "./resumen_pendientes.vue?vue&type=style&index=0&id=64a76b55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a76b55",
  null
  
)

export default component.exports